/* mk-transitions.js — one-time scroll reveals for MISHKA (≈1 KB).
   Load with `defer`. Opacity/transform only; content already on screen is
   never hidden; without JS or with reduced motion nothing is hidden.     */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return;      // not in theme editor

  var SKIP = '[id$="__header"],[id*="cart-drawer"],[id$="__footer"],[id$="__sub-footer"],' +
             '[id*="__product-information"],[id*="__countdown"],[id*="__mk_copy"],[id*="__main"]';
  var FIXED = '.mk-dd-bar,cart-drawer,[class*="--fixed"],[class*="sticky"],form[action*="/cart"]';
  var targets = [];

  // a) Section content: first real child of each section (section bg stays put)
  document.querySelectorAll('.shopify-section').forEach(function (s) {
    if (s.matches(SKIP) || s.offsetHeight < 40) return;
    var k = s.firstElementChild;
    while (k && /^(STYLE|LINK|SCRIPT|NOSCRIPT)$/.test(k.tagName)) k = k.nextElementSibling;
    if (!k || k.querySelector(FIXED)) return;          // never transform a fixed bar's parent
    if (s.querySelector('.grid__item')) return;          // grids handled per card below
    targets.push(k);
  });

  // b) Product grid cards: staggered 70ms, cap 6 per row-batch
  document.querySelectorAll('.collection-grid-section .grid__item, product-recommendations .grid__item')
    .forEach(function (el, i) { el.style.setProperty('--mk-d', (i % 6) * 70 + 'ms'); targets.push(el); });

  var fold = innerHeight * 0.95;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('mk-in');                    // one-time only
      io.unobserve(e.target);
      e.target.addEventListener('transitionend', function done() {
        e.target.removeEventListener('transitionend', done);
        e.target.removeAttribute('data-mk-reveal');       // drop styles/layer after reveal
        e.target.classList.remove('mk-in');
        e.target.style.removeProperty('--mk-d');
      });
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  targets.forEach(function (el) {
    if (el.getBoundingClientRect().top < fold) return;   // above the fold: leave alone
    el.setAttribute('data-mk-reveal', '');
    io.observe(el);
  });
  document.documentElement.classList.add('mk-tr');
})();
